import front from './view';

export default [
  {
    path: 'cs', // 공지목록
    redirect: 'cs/notice',
  },
  {
    path: 'cs/notice', // 공지목록
    component: front('/cs/notice'),
  },
  {
    path: 'cs/notice/:sq', // 공지목록_본문보기
    component: front('/cs/noticeView'),
  },
  {
    path: 'cs/info', // 자료실 목록
    component: front('/cs/info'),
  },
  {
    path: 'cs/info/:sq', // 정보자료실_본문보기
    component: front('/cs/infoView'),
  },
  {
    path: 'cs/faq',
    component: front('/cs/faq'),
  },
  {
    path: 'cs/qna',
    component: front('/cs/qna'),
  },
  {
    path: 'cs/qna/applyMember', // 문의하기-회원
    component: front('/cs/apply'),
    props: { authorType: 'member' },
  },
  {
    path: 'cs/qna/applyPersonal', // 문의하기-비회원
    component: front('/cs/apply'),
    props: { authorType: 'personal' },
  },
  {
    path: 'cs/qna/complete', // 문의 완료
    component: front('/cs/complete'),
  },
  {
    path: 'cs/manual', // KS인증매뉴얼다운로드
    component: front('/cs/manual'),
  },
];



// WEBPACK FOOTER //
// ./src/router/front/cs.js